import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
// Use environment variables in production, fallback to hardcoded values in development
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || (process.env.NODE_ENV !== 'production' ? "AIzaSyDDMLpznFHmsOTlDbTojrCs3bBZIGsQxy4" : undefined),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || (process.env.NODE_ENV !== 'production' ? "randommockups-ce8e5.firebaseapp.com" : undefined),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || (process.env.NODE_ENV !== 'production' ? "randommockups-ce8e5" : undefined),
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || (process.env.NODE_ENV !== 'production' ? "randommockups-ce8e5.firebasestorage.app" : undefined),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || (process.env.NODE_ENV !== 'production' ? "866267708157" : undefined),
  appId: process.env.REACT_APP_FIREBASE_APP_ID || (process.env.NODE_ENV !== 'production' ? "1:866267708157:web:27d30b6231b47d672c9c94" : undefined)
};

// Check if we have valid config
const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);
const hasValidConfig = missingKeys.length === 0;

// Only validate in production
if (!hasValidConfig && process.env.NODE_ENV === 'production') {
  throw new Error(`Missing required Firebase environment variables: ${missingKeys.join(', ')}`);
}

// Show info about config source in development
if (process.env.NODE_ENV !== 'production') {
  const usingEnvVars = process.env.REACT_APP_FIREBASE_API_KEY ? 'environment variables' : 'hardcoded fallback values';
  console.log(`🔧 Firebase using ${usingEnvVars} for development`);
}

console.log('Firebase config loaded:', {
  apiKey: firebaseConfig.apiKey ? 'SET' : 'NOT SET',
  authDomain: firebaseConfig.authDomain ? 'SET' : 'NOT SET',
  projectId: firebaseConfig.projectId ? 'SET' : 'NOT SET',
  storageBucket: firebaseConfig.storageBucket ? 'SET' : 'NOT SET',
  messagingSenderId: firebaseConfig.messagingSenderId ? 'SET' : 'NOT SET',
  appId: firebaseConfig.appId ? 'SET' : 'NOT SET'
});

// Initialize Firebase with error handling
let app;
let auth;
let googleProvider;
let db;
let storage;

// Initialize Firebase
try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  db = getFirestore(app);
  storage = getStorage(app);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  
  // Safari-specific error handling
  if (error.message && error.message.includes('auth')) {
    console.error('🌐 Safari: Firebase Auth initialization failed - this may be a Safari-specific issue');
  }
  
  // Create mock objects to prevent app crashes
  auth = null;
  googleProvider = null;
  db = null;
  storage = null;
}

// Add global error handler for Firebase-related errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && 
      (event.error.message.includes('429') || 
       event.error.message.includes('Too Many Requests'))) {
    console.warn('⚠️ Rate limit detected, this is usually temporary');
    event.preventDefault(); // Prevent the error from showing in console
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message) {
    if (event.reason.message.includes('429') || 
        event.reason.message.includes('Too Many Requests')) {
      console.warn('⚠️ Rate limit detected in promise rejection, this is usually temporary');
      event.preventDefault(); // Prevent the error from showing in console
    } else if (event.reason.message.includes('INTERNAL ASSERTION FAILED') ||
               event.reason.message.includes('Pending promise was never set')) {
      console.warn('🌐 Firebase internal assertion error (concurrent auth operations) - ignoring');
      event.preventDefault(); // Prevent the error from showing in console
    }
  }
});

export { auth, googleProvider, db, storage };

export default app;
